module.exports = __webpack_public_path__ + "img/Suitcase_icon.b6c12de8.svg";